import { render, staticRenderFns } from "./FormatSelection.vue?vue&type=template&id=57d24b57&scoped=true"
import script from "./FormatSelection.vue?vue&type=script&lang=js"
export * from "./FormatSelection.vue?vue&type=script&lang=js"
import style0 from "./FormatSelection.vue?vue&type=style&index=0&id=57d24b57&prod&lang=postcss&scoped=true"
import style1 from "./FormatSelection.vue?vue&type=style&index=1&id=57d24b57&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d24b57",
  null
  
)

export default component.exports